import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Operations from '../../../../operations'
import Selectors from '../../../../selectors'
import { IncidentReport } from '../../../../components/reports'
import { get } from 'lodash'
import { GroupsSidebarNavigation } from '../components'
import styled from 'styled-components'

export function GroupIncidentAnalytics(props) {
  const { isLoading, error, data, fetchData } = props

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div style={styles.mainContainer}>
      <StyledNavigation>
        <GroupsSidebarNavigation />
      </StyledNavigation>
      <StyledInnerContainer>
        <IncidentReport
          data={data}
          isLoading={isLoading}
          error={error}
          title="Incidents per month"
        />
      </StyledInnerContainer>
    </div>
  )
}

const styles = {
  mainContainer: {
    margin: '0 auto',
    maxWidth: 2000,
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    minHeight: 'calc(100vh - 64px)',
  },
}

const StyledInnerContainer = styled.div`
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  height: 100%;
  width: 100%
`

const StyledNavigation = styled.div`
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    display: none;
  }
`

GroupIncidentAnalytics.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
}

const STATE_ID = 'group_incidents'
const mapStateToProps = (state) => {
  const data = get(state, `data.requests.${STATE_ID}.response`)
  return {
    data: Selectors.populateWithListData(state, {
      data,
      populate: [],
    }),
    isLoading: get(state, `data.requests.${STATE_ID}.isLoading`),
    error: get(state, `data.requests.${STATE_ID}.error`),
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => {
    dispatch(
      Operations.fetchData({
        url: 'aggregations/incidents',
        id: STATE_ID,
      })
    )
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupIncidentAnalytics)
